import { RetrieveSignatureSessionResponseBody } from 'bff'
import React from 'react'

export interface SignatureContext {
  createSession: () => Promise<RetrieveSignatureSessionResponseBody>
  expireSignatureSession: () => Promise<void>
  onSignatureReceived: (signature: string) => void
  onSignaturePersisted?: (signature: string) => void
  retrieveSignatureSession: () => Promise<RetrieveSignatureSessionResponseBody>
  onDependentUpdate?: (path: string, value: any) => void
}

const SignatureContext = React.createContext<SignatureContext | undefined>(
  undefined
)

export const useSignature = () => React.useContext(SignatureContext)!

export const SignatureProvider = ({
  children,
  ...value
}: {
  children: React.ReactNode
} & SignatureContext) => {
  return (
    <SignatureContext.Provider value={value}>
      {children}
    </SignatureContext.Provider>
  )
}
